export default function getResource(label) {
    const resources = {
        free: 'GRATUIT',
        value: 'valeur'
    };
    return resources[label];
}
